import React, { ReactNode } from 'react';

const Large = ({ children, ...props }: { children: ReactNode }) => (
  <div className="flex flex-col w-[85%] md:w-full md:max-w-[466px] flex-shrink-0" {...props}>
    {children}
  </div>
);

export default Large;
